import React, {Component, useState} from 'react';
import {loadStripe} from '@stripe/stripe-js';
import {CardElement, Elements, useElements, useStripe,} from '@stripe/react-stripe-js';
import {PageView} from "../tracking/util"
import './../styles/card-details.css';

const CARD_OPTIONS = {
    iconStyle: 'solid',
    style: {
        base: {
            iconColor: '#00000',
            color: '#4A5568',
            fontWeight: 500,
            fontFamily: 'Nunito Sans, sans-serif',
            fontSize: '14px',
            fontSmoothing: 'antialiased',
            ':-webkit-autofill': {
                color: '#4A5568',
            },
            '::placeholder': {
                color: '#4A5568',
            },
            boxShadow: "0 0 20px rgba(45, 202, 140, 0.1)",
            borderRadius: "0.375rem"
        },
        invalid: {
            iconColor: '#f25767',
            color: '#f25767',
        },
    },
};

const CardField = ({onChange}) => (

    <div className="">
        <CardElement options={CARD_OPTIONS} onChange={onChange}/>
    </div>
);

const Field = ({
                   label,
                   id,
                   type,
                   placeholder,
                   required,
                   autoComplete,
                   value,
                   onChange,
               }) => (
    <div className="row">
        <div className="col-md-12">
            <div className="form-group">
                <label htmlFor={id} className="form-control-label">
                    {label}
                </label>
                <input
                    className="form-control"
                    id={id}
                    type={type}
                    placeholder={placeholder}
                    required={required}
                    autoComplete={autoComplete}
                    value={value}
                    onChange={onChange}
                />

            </div>
        </div>
    </div>
);

const SubmitButton = ({processing, error, children, disabled}) => (
    <button
        className={`btn btn-sm btn-primary ${error ? 'SubmitButton--error' : ''}`}
        type="submit"
        disabled={processing || disabled}>

        {processing ? 'Processing...' : children}
    </button>
);

const ErrorMessage = ({children}) => (
    <div className="ErrorMessage" role="alert">
        <svg width="16" height="16" viewBox="0 0 17 17">
            <path
                fill="#FFF"
                d="M8.5,17 C3.80557963,17 0,13.1944204 0,8.5 C0,3.80557963 3.80557963,0 8.5,0 C13.1944204,0 17,3.80557963 17,8.5 C17,13.1944204 13.1944204,17 8.5,17 Z"
            />
            <path
                fill="#6772e5"
                d="M8.5,7.29791847 L6.12604076,4.92395924 C5.79409512,4.59201359 5.25590488,4.59201359 4.92395924,4.92395924 C4.59201359,5.25590488 4.59201359,5.79409512 4.92395924,6.12604076 L7.29791847,8.5 L4.92395924,10.8739592 C4.59201359,11.2059049 4.59201359,11.7440951 4.92395924,12.0760408 C5.25590488,12.4079864 5.79409512,12.4079864 6.12604076,12.0760408 L8.5,9.70208153 L10.8739592,12.0760408 C11.2059049,12.4079864 11.7440951,12.4079864 12.0760408,12.0760408 C12.4079864,11.7440951 12.4079864,11.2059049 12.0760408,10.8739592 L9.70208153,8.5 L12.0760408,6.12604076 C12.4079864,5.79409512 12.4079864,5.25590488 12.0760408,4.92395924 C11.7440951,4.59201359 11.2059049,4.59201359 10.8739592,4.92395924 L8.5,7.29791847 L8.5,7.29791847 Z"
            />
        </svg>
        {children}
    </div>
);

const ResetButton = ({onClick}) => (
    <button type="button" className="ResetButton" onClick={onClick}>
        <svg width="32px" height="32px" viewBox="0 0 32 32">
            <path
                fill="#FFF"
                d="M15,7.05492878 C10.5000495,7.55237307 7,11.3674463 7,16 C7,20.9705627 11.0294373,25 16,25 C20.9705627,25 25,20.9705627 25,16 C25,15.3627484 24.4834055,14.8461538 23.8461538,14.8461538 C23.2089022,14.8461538 22.6923077,15.3627484 22.6923077,16 C22.6923077,19.6960595 19.6960595,22.6923077 16,22.6923077 C12.3039405,22.6923077 9.30769231,19.6960595 9.30769231,16 C9.30769231,12.3039405 12.3039405,9.30769231 16,9.30769231 L16,12.0841673 C16,12.1800431 16.0275652,12.2738974 16.0794108,12.354546 C16.2287368,12.5868311 16.5380938,12.6540826 16.7703788,12.5047565 L22.3457501,8.92058924 L22.3457501,8.92058924 C22.4060014,8.88185624 22.4572275,8.83063012 22.4959605,8.7703788 C22.6452866,8.53809377 22.5780351,8.22873685 22.3457501,8.07941076 L22.3457501,8.07941076 L16.7703788,4.49524351 C16.6897301,4.44339794 16.5958758,4.41583275 16.5,4.41583275 C16.2238576,4.41583275 16,4.63969037 16,4.91583275 L16,7 L15,7 L15,7.05492878 Z M16,32 C7.163444,32 0,24.836556 0,16 C0,7.163444 7.163444,0 16,0 C24.836556,0 32,7.163444 32,16 C32,24.836556 24.836556,32 16,32 Z"
            />
        </svg>
    </button>
);

const CheckoutForm = (consent) => {
    const stripe = useStripe();
    const elements = useElements();
    const [error, setError] = useState(null);
    const [cardComplete, setCardComplete] = useState(false);
    const [processing, setProcessing] = useState(false);
    const [paymentMethod, setPaymentMethod] = useState(null);
    const [billingDetails, setBillingDetails] = useState({
        email: '',
        phone: '',
        name: '',
    });

    const saveCard = (billingDetails, paymentMethod) => {
        console.log("Calling backendz");

        const body = {
            billingDetails,
            paymentMethod
        };

        return fetch("/api/save-card", {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body)
        })
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!stripe || !elements) {
            // Stripe.js has not loaded yet. Make sure to disable
            // form submission until Stripe.js has loaded.
            return;
        }

        if (error) {
            elements.getElement('card').focus();
            return;
        }

        if (cardComplete) {
            setProcessing(true);
        }

        const payload = await stripe.createPaymentMethod({
            type: 'card',
            card: elements.getElement(CardElement),
            billing_details: billingDetails,
        });


        if (payload.error) {
            setProcessing(false);
            setError(payload.error);
        } else {
            saveCard(billingDetails, payload.paymentMethod).then((response) => {
                console.log(response);

                if (response.status === 200) {
                    setPaymentMethod(payload.paymentMethod);
                } else {
                    setError({message: "Error saving Card please send an e-mail to us."});
                }

                setProcessing(false);


            }).catch(error => {
                setError({message: "Error saving Card please send an e-mail to us."});
            });

        }
    };

    const reset = () => {
        setError(null);
        setProcessing(false);
        setPaymentMethod(null);
        setBillingDetails({
            email: '',
            phone: '',
            name: '',
        });
    };

    return paymentMethod ? (
        <div className="Result">
            <div className="ResultTitle" role="alert">
                Card Saved
            </div>
            <div className="ResultMessage">
                Thanks for saving a payment method. No money was charged, but we
                generated a PaymentMethod: {paymentMethod.id} Please save this for your reference.
            </div>
            <ResetButton onClick={reset}/>
        </div>
    ) : (
        <form onSubmit={handleSubmit}>

            <Field
                label="Name"
                id="name"
                type="text"
                placeholder="Jane Doe"
                required
                autoComplete="name"
                value={billingDetails.name}
                onChange={(e) => {
                    setBillingDetails({...billingDetails, name: e.target.value});
                }}
            />
            <Field
                label="Email"
                id="email"
                type="email"
                placeholder="janedoe@gmail.com"
                required
                autoComplete="email"
                value={billingDetails.email}
                onChange={(e) => {
                    setBillingDetails({...billingDetails, email: e.target.value});
                }}
            />
            <Field
                label="Phone"
                id="phone"
                type="tel"
                placeholder="(941) 555-0123"
                required
                autoComplete="tel"
                value={billingDetails.phone}
                onChange={(e) => {
                    setBillingDetails({...billingDetails, phone: e.target.value});
                }}
            />

            <label className="form-control-label">
                Card Number
            </label>

            <fieldset className="FormGroup">
                <CardField
                    onChange={(e) => {
                        setError(e.error);
                        setCardComplete(e.complete);
                    }}
                />
            </fieldset>


            {error && <ErrorMessage className="row">{error.message}</ErrorMessage>}

            <SubmitButton processing={processing} error={error} disabled={!stripe || !consent.consent}>
                Save Card
            </SubmitButton>
        </form>
    );
};


const stripePromise = loadStripe('pk_live_51HbVlqDc9YxrvusVswnFWIVdoHdMfPPBzQ33ARMNLkqVt2Uqwojt63gByHX8ov7f9iibWt7R2ToymOsFszSCUodZ002hQx78rQ');

class SaveCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            enableSave: false,
            checkboxCancel: false,
            checkboxOutOfNetwork: false
        };
        this.consentClicked = this.consentClicked.bind(this);
    }

    componentDidMount() {
        PageView();
    }

    consentClicked(event) {

        if (event.target.id === 'checkboxCancel') {

            this.setState({checkboxCancel: !this.state.checkboxCancel});

            if (!this.state.checkboxCancel && this.state.checkboxOutOfNetwork) {
                this.setState({enableSave: true});
            } else {
                this.setState({enableSave: false});
            }
        }

        else if (event.target.id === 'checkboxOutOfNetwork') {

            this.setState({checkboxOutOfNetwork: !this.state.checkboxOutOfNetwork});

            if (!this.state.checkboxOutOfNetwork && this.state.checkboxCancel) {
                this.setState({enableSave: true});
            } else {
                this.setState({enableSave: false});
            }
        }

    }

    render() {
        return (
            <div className="slice slice-sm bg-section-secondary">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-9">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="row row-grid align-items-center">
                                                <div className="col-lg-8">
                                                    <div className="media align-items-center">
                                                        <div className="media-body">
                                                            <p className="text-muted lh-150 text-sm mb-0">
                                                                <div className="">
                                                                    <label>Credit card on file on is required to confirm all first appointments. Your credit card will NOT be
                                                                        charged until after your scheduled appointment time.
                                                                        <br/>Cancellation Policy: If an appointment is missed, or canceled within 24 business hours, you will be
                                                                        charged the full session fee.</label>
                                                                </div>
                                                                <div className="form-group custom-control custom-checkbox">
                                                                    <input type="checkbox" className="checkbox form-control custom-control-input" id="checkboxCancel"
                                                                           value={this.state.checkboxCancel}
                                                                           onClick={this.consentClicked}/>
                                                                    <label className="custom-control-label" for="checkboxCancel">
                                                                        I have read and agree to the cancellation policy above.</label>

                                                                </div>
                                                                <div className="form-group custom-control custom-checkbox">
                                                                    <input type="checkbox" className="form-control custom-control-input" id="checkboxOutOfNetwork"
                                                                           value={this.state.checkboxOutOfNetwork}
                                                                           onClick={this.consentClicked}/>
                                                                    <label className="custom-control-label" for="checkboxOutOfNetwork">
                                                                        I understand that Empower Integrative Psychiatry is out of network on my insurance plan and does not bill
                                                                        insurance directly. I understand I am responsible for payment in full at the time service is rendered,
                                                                        unless other arrangements have been made.</label>
                                                                </div>
                                                            </p>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="AppWrapper" style={{'width': "100%"}}>
                                        <Elements stripe={stripePromise}>
                                            <CheckoutForm consent={this.state.enableSave}/>
                                        </Elements>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    };
}

export default SaveCard;